<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<Input type="text" style="width: 150px;" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 150px;" v-model="formInline.PhoneNo" placeholder="手机号码">
				<span slot="prepend">手机号码</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<!-- <FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem> -->
		</Form>
		<Table class="tableExtend" :columns="columns1" :data="data1" :height="tableHeight" ref="tableData"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getGroupAdjunctInfoUrl" @listData='getDeviceData'></MyPage>
	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
		},
		data() {
			return {
				getGroupAdjunctInfoUrl: webapi.base_api_url + '/Member/GetGroupAdjunctList',
				tableHeight: "650",
				formInline: {
					MemberName: '',
					PhoneNo: '',
				},
				//table标题数据
				columns1: [
					{
						title: '会员头像',
						key: 'Headimgurl',
						minWidth: 80,
						render: (h, params) => {
							let arr = [];
							if (params.row.Headimgurl == "" || params.row.Headimgurl == undefined) {
								arr.push(h('div', "未上传"))
							} else {
								arr.push(
									h('div', [
										h('img', {
											style: {
												width: "24px",
												height: "24px",
												verticalAlign: "middle",
												borderRadius: "50%"
											},
											attrs: {
												src: /http.*/i.test(params.row.Headimgurl) ? params.row.Headimgurl : webapi.base_api_url + params.row.Headimgurl
											}
										})
									])
								)
							}
							return arr;
						}
					},
					{
						title: '会员ID',
						key: 'MemberId',
						width: '260',
					}, 
					{
						title: '会员名称',
						key: 'MemberName',
						minWidth: 150,
					},
					{
						title: '手机号码',
						key: 'PhoneNo',
						minWidth: 150,
					},
					{
						title: '所属集团',
						key: 'GroupName',
						minWidth: 150,
					},
					{
						title: '所属运营商',
						key: 'OperatorName',
						minWidth: 150,
					},
					{
						title: '状态',
						key: 'State',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.StateDesc
							);
						}
					},
					{
						title: '注册时间',
						key: 'CreateTime',
						minWidth: 200,
					},
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			this.getTableHeight();
			window.addEventListener('resize', _this.getTableHeight)
		},
		updated() {
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})

		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: '集团附属会员',
					columns: this.columns2,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						k.State = k.StateDesc;
						return k;
					})
				})
			},
			getDeviceData: function(data) {
				// console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 210 - (window.innerWidth < 1138 ? 60 : 0);
			}
		},
	}
</script>

<style>
	.tableExtend td.ivu-table-expanded-cell {
		padding: 1px 60px;
		background: #f8f8f9;
	}

	.tableExtend {
		width: 100%;
	}
</style>
